import React, { Component } from 'react';
import { connect } from 'react-redux';
import Button from 'react-bootstrap-button-loader';
import { Link } from 'react-router';
import get from 'lodash/get';
import { Field, reduxForm } from 'redux-form';
import CopyToClipboard from 'react-copy-to-clipboard';
import { toastr } from 'react-redux-toastr';
import { PublisherApi } from '../../../api';
import { setLoader, removeLoader } from '../../../actions';
import { SelectField } from '../../form';
import { ButtonAdd, ButtonCopy } from '../../common/buttons';

class EmailPixel extends Component {
  state = { edit: false };

  componentDidMount() {
    this.fetchCnames();
  }

  onFormSubmit(vals) {
    const { dispatch, website, websites } = this.props;

    const args = [website.uuid, vals];
    dispatch(setLoader('WebsiteCnameForm'));
    dispatch(
      PublisherApi.actions.websiteCnameUpdate.post(...args, (error, success) => {
        dispatch(removeLoader('WebsiteCnameForm'));
        if (success) {
          let collection = [...websites.data];

          collection = [...websites.data].map(obj => {
            return obj.uuid === success.data.uuid ? success.data : obj;
          });

          if (success.data.uuid) {
            dispatch(PublisherApi.actions.pixel.get({ publisher_website_id: website.uuid }));
          }

          dispatch({
            type: PublisherApi.events.websites.actionSuccess,
            syncing: false,
            data: { ...websites, data: collection, meta: { ...websites.meta } },
          });
        }
      }),
    );

    this.setState({ edit: false });
  }

  fetchCnames(_params = {}) {
    const { dispatch } = this.props;
    dispatch(PublisherApi.actions.cnames());
  }

  render() {
    const { website, pixel, cnames, handleSubmit } = this.props;

    const styleSnippet = `<style type="text/css">
                            img.jdx-img + div {display:none;}
                          </style>`;

    const emailSnippet = get(pixel, 'data.email_snippet', null);

    const activeCnames = (cnames.data || [])
      .filter(e => e.status === 'active')
      .map(e => {
        return { label: `jdx.${e.domain}`, value: e.id };
      });

    const currentCname = activeCnames.filter(cname => cname.value === website.publisher_c_name_id);

    const SelectCname = () => {
      return (
        <div>
          <h3>Please choose a CNAME</h3>
          <hr />

          <p>
            <small>
              <strong>Note: </strong>
              If you created a CNAME and don&apos;t see it listed below, please wait for it to become active and it&apos;ll show up.
            </small>
          </p>

          <form onSubmit={handleSubmit(this.onFormSubmit.bind(this))} className="m-t">
            <Field
              type="text"
              name="website[publisher_c_name_id]"
              placeholder="Select a CNAME"
              label=""
              component={SelectField}
              options={activeCnames}
              normalize={e => get(e, 'value', null)}
            />

            <p className="text-center">
              <Button type="submit" bsStyle="primary" bsSize="small">
                Update
              </Button>
              &nbsp;
              {this.state.edit ? (
                <Button bsStyle="danger" bsSize="small" onClick={_e => this.setState({ edit: false })}>
                  Go Back
                </Button>
              ) : null}
            </p>

            <p className="text-center">or</p>

            <div className="text-center">
              <Link className="btn btn-sm btn-primary" to="/publisher/home/cnames">
                Add New CNAME
              </Link>
            </div>
          </form>
          <br />
        </div>
      );
    };

    const AddCname = () => {
      return (
        <div>
          <h3>Please choose a CNAME</h3>
          <hr />
          <p>There are no active CNAMEs available to choose from, please create a new CNAME to continue.</p>
          <p>
            <Link to="/publisher/home/cnames">
              <ButtonAdd btnLabel="Add CNAME" />
            </Link>
          </p>
          <p>
            <small>
              <strong>Note: </strong>
              If you&apos;ve already created a CNAME please wait for it become active and it&apos;ll show up here.
            </small>
          </p>
          <br />
        </div>
      );
    };

    const CnameSelector = () => {
      return (
        <div>
          {activeCnames.length > 0 ? SelectCname() : AddCname()}

          <h3>A little bit about CNAME</h3>
          <hr />

          <h4>What is a CNAME?</h4>

          <p>
            <span>
              A Canonical Name, or CNAME record, is a type of Domain Name System (DNS) record that maps an alias name to a true canonical domain name.
              JobAdX uses this alias as the tag domain.&nbsp;
            </span>
          </p>

          <p>
            <span>Your system administrator, or whoever has set up your domain name, can help create a CNAME record.&nbsp;</span>
          </p>
          <br />

          <h4>What are the benefits of using a CNAME?</h4>

          <p>
            A CNAME improves the user experience as your links will appear to be coming from your domain, and allows filters to email inboxes to see
            and recognize content that&apos;s authentic to the publisher.&nbsp;
          </p>
          <br />

          <h4>How does it work?</h4>

          <ol style={{ paddingLeft: 15 }}>
            <li>
              <span>Send us the domain that you&apos;d like to use for the CNAME record</span>
            </li>
            <li>
              <span>Using the subdomain &apos;jdx&apos;, we&apos;ll pass over a Host Name&nbsp;</span>
            </li>
            <li>
              <span>In your Domain Name System (DNS), point the subdomain &apos;jdx&apos; to the Host Name we&apos;ve provided&nbsp;</span>
            </li>
            <li>
              <span>We&apos;ll confirm that the CNAME alias name is successfully redirecting to the destination.&nbsp;</span>
            </li>
          </ol>

          <p style={{ padding: 10, background: '#fff', maxWidth: 583, marginTop: 20 }} className="text-center">
            <img className="img-responsive" src="https://storage.googleapis.com/jobadx/c_name.png" alt="" />
          </p>
        </div>
      );
    };

    const EmailTag = () => {
      return (
        <div>
          <p className="text-center" style={{ fontSize: '1.1em' }}>
            <span style={{ fontWeight: '800' }}>Current CNAME:</span> {currentCname.length > 0 ? currentCname[0].label : null}
          </p>
          <p className="text-center">
            <Button bsStyle="primary" bsSize="xsmall" onClick={_e => this.setState({ edit: true })}>
              Change CNAME
            </Button>
          </p>
          <hr />
          <br />
          <h3>1. Add the pixel code to email</h3>
          <p>Copy the pixel code and place it in the email body where you want the ads to be displayed.</p>
          <CopyToClipboard text={emailSnippet} onCopy={() => toastr.success('Snippet copied to clipboard!')}>
            <ButtonCopy bsStyle="primary" bsSize="small" btnLabel="Copy to clipboard" />
          </CopyToClipboard>
          <pre id="pixel-view" className="m-t-md">
            {emailSnippet}
          </pre>{' '}
          <br />
          <h3>2. Add the style tag to the head of the email</h3>
          <p>Copy the style tag and place it in the head of your email template.</p>
          <CopyToClipboard text={styleSnippet} onCopy={() => toastr.success('Snippet copied to clipboard!')}>
            <ButtonCopy bsStyle="primary" bsSize="small" btnLabel="Copy to clipboard" />
          </CopyToClipboard>
          <pre id="pixel-view" className="m-t-md">
            {styleSnippet}
          </pre>{' '}
          <br />
          <h3>3. Replace the &lt;keyword&gt; and &lt;location&gt; variables in the pixel code</h3>
          <p>
            In the above pixel code replace <strong>&lt;keyword&gt;</strong> variable with a keyword of your choice and &nbsp;
            <strong>&lt;location&gt;</strong> variable with a location of your choice.
          </p>
          <p>
            A keyword can be a job title or search keyword and location can be a job location, city, state, country or postal code that the email
            subscriber is interested in.
          </p>
          <p>Typically you would be using the values from the email database or email list that will be used in the email campaign.</p>
          <br />
          <h3>4. Replace the &lt;aid&gt; variable in the pixel code</h3>
          <p>
            There are in total 4 places in above pixel code where you need to replace the <strong>&lt;aid&gt;</strong> with a unique identifier for
            each email that is being sent out. Please make sure to replace the <strong>&lt;aid&gt;</strong>&nbsp; variable with same value at all 4
            the places.
          </p>
          <p>This unique identifier will help us run the auction and associate it with a email when it is opened by the subscriber.</p>
          <p>
            Typically you would be generating this identifier using the programming language that is being used in the backend and pass it to the
            email template where the <strong>&lt;aid&gt;</strong> variable will be replaced with the value.
          </p>
          <p>
            To help you generate the unique identifier we&apos;ve complied a list of libraries or plugins in different programming languages that can
            be used.
            <br />
            <br />
          </p>
          <ul style={{ paddingLeft: 20 }}>
            <li>
              <a target="_blank" rel="noopener noreferrer" href="https://github.com/codeyu/nanoid-net">
                C#
              </a>
            </li>
            <li>
              <a target="_blank" rel="noopener noreferrer" href="https://github.com/zelark/nano-id">
                Clojure & ClojureScript
              </a>
            </li>
            <li>
              <a target="_blank" rel="noopener noreferrer" href="https://github.com/mamantoha/nanoid.cr">
                Crystal
              </a>
            </li>
            <li>
              <a target="_blank" rel="noopener noreferrer" href="https://github.com/pd4d10/nanoid">
                Dart
              </a>
            </li>
            <li>
              <a target="_blank" rel="noopener noreferrer" href="https://github.com/matoous/go-nanoid">
                Go
              </a>
            </li>
            <li>
              <a target="_blank" rel="noopener noreferrer" href="https://github.com/railsmechanic/nanoid">
                Elixir
              </a>
            </li>
            <li>
              <a target="_blank" rel="noopener noreferrer" href="https://github.com/4e6/nanoid-hs">
                Haskell
              </a>
            </li>
            <li>
              <a target="_blank" rel="noopener noreferrer" href="https://github.com/aventrix/jnanoid">
                Java
              </a>
            </li>
            <li>
              <a target="_blank" rel="noopener noreferrer" href="https://github.com/hidehalo/nanoid-php">
                PHP
              </a>
            </li>
            <li>
              <a target="_blank" rel="noopener noreferrer" href="https://github.com/puyuan/py-nanoid">
                Python
              </a>
            </li>
            <li>
              <a target="_blank" rel="noopener noreferrer" href="https://github.com/radeno/nanoid.rb">
                Ruby
              </a>
            </li>
            <li>
              <a target="_blank" rel="noopener noreferrer" href="https://github.com/nikolay-govorov/nanoid">
                Rust
              </a>
            </li>
            <li>
              <a target="_blank" rel="noopener noreferrer" href="https://github.com/antiflasher/NanoID">
                Swift
              </a>
            </li>
          </ul>
          <p>If you don&apos;t find the programming language that is being used by you in the above list, google is your best bet!</p>
        </div>
      );
    };

    return <div>{this.state.edit && website.publisher_c_name_id ? CnameSelector() : website.publisher_c_name_id ? EmailTag() : CnameSelector()}</div>;
  }
}

const WebsiteCnameForm = reduxForm({
  form: 'WebsiteCnameForm',
});

const mapStateToProps = (state, ownProps) => {
  const { loader, publisher } = state;
  const websites = get(state, 'publisher.websites.data', {});
  const { website } = ownProps;

  const formIsLoading = loader.includes('WebsiteCnameForm');

  const initialValues = {
    website: {
      publisher_c_name_id: website.publisher_c_name_id,
    },
  };

  return { cnames: publisher.cnames.data, isLoading: publisher.cnames.loading, initialValues, formIsLoading, websites };
};

export default connect(mapStateToProps)(WebsiteCnameForm(EmailPixel));
